module.exports = __webpack_public_path__ + "media/aerial.33f03dbe.jpg";